module.exports = __webpack_public_path__ + "static/media/pepe.64414dad.png";